import { render } from "./BgLayerList.vue?vue&type=template&id=2d621371"
import script from "./BgLayerList.vue?vue&type=script&lang=js"
export * from "./BgLayerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__